import { Box, BoxProps, ColorOptions, Image as NewImage, Spacer, Text as NewText } from '@jfs/ui-new'
import { isIE } from '@jfs/utils'
import { useNavigation } from '@react-navigation/native'
import { FC, useState } from 'react'
import ContactUs from '../../comps/ContactUs'
import { Modal, ModalTypes } from '../../comps/ModalWeb'
import Navbar from '../../comps/Nav'
import NavMob from '../../comps/NavMobile'
import useFontSize from '../../util/useFontSize'
import usePadding from '../../util/usePadding'
import { isDesktopWidth, isMobileWidth, isTabletWidth, useWindowDimensions } from '../../util/util'
import { sectionData } from './data'
import SectionList from './sectionList'

const SeamlessPay: FC = () => {
  const [navVisible, setNavVisible] = useState(false)
  const navigation = useNavigation()
  const handleNav = (): void => {
    document.body.style.overflow = 'hidden' // body scroll disabled
    setNavVisible((prev) => !prev)
  }
  const { headerSize, headerLineHeight } = useFontSize()

  const setVisiblity = (): void => {
    document.body.style.overflow = 'scroll' // body scroll disabled
    setNavVisible(false)
  }
  const viewPortWidth = useWindowDimensions()

  const respPadding = usePadding()
  const themedStyle = styles(viewPortWidth, respPadding)

  const nav = (
    <Box>
      <NavMob onPress={setVisiblity} />
    </Box>
  )

  const isMobile = isMobileWidth(viewPortWidth)
  const isTab = isTabletWidth(viewPortWidth)
  const isDesktop = isDesktopWidth(viewPortWidth)
  return (
    <>
      <Modal view={nav} visible={navVisible} onPress={setVisiblity} type={ModalTypes.NAVBAR_RIGHT} />
      <Navbar onPress={handleNav} isLightBackground={true} hamBurgerType="secondary" />
      <Box {...themedStyle.outerontainer}>
        <Box {...themedStyle.container}>
          <Box {...themedStyle.leftBox} marginTop={isMobile ? 14 : 0}>
            <Box w={isTab ? '90%' : isIE() ? '100%' : undefined}>
              <NewText
                fontSize={!isMobile ? headerSize + 2 : headerSize}
                lineHeight={headerLineHeight + 6}
                fontFamily="jiotype-black">
                {sectionData?.header}
              </NewText>
            </Box>
            {sectionData?.subHeader?.length > 0 && (
              <>
                <NewText letterSpacing={0.8} fontSize={28} fontWeight="900">
                  {sectionData?.subHeader}
                </NewText>
              </>
            )}
          </Box>
          <Box {...themedStyle.imageContainer}>
            <NewImage
              resizeMode={'contain'}
              source={sectionData.lpImage}
              height={isMobile ? '100%' : isTab ? '100%' : 600}
              width={isMobile ? '100%' : isTab ? '100%' : 560}
            />
          </Box>
        </Box>
        <SectionList data={sectionData.data} navigation={navigation} />
        <Spacer size={isTab ? 100 : isDesktop ? 140 : undefined} />
        <ContactUs type={'footer'} />
      </Box>
    </>
  )
}

const styles = (breakpoint: number, responsivePadding: number) => {
  // const responsivePadding = getPadding(breakpoint)
  const isMobile = isMobileWidth(breakpoint)
  const isTab = isTabletWidth(breakpoint)
  return {
    outerontainer: {
      display: 'flex',
      flexDirection: 'column',
      overflow: 'hidden',
      margin: 0,
      bg: 'WHITE',
      padding: 0,
      paddingTop: isTab ? 50 : undefined,
    } as BoxProps,
    container: {
      display: 'flex',
      // bg: 'WHITE',
      position: 'relative',
      flexWrap: 'wrap-reverse',
      flexDirection: 'row',
      justifyContent: 'space-between',
      paddingHorizontal: responsivePadding,
      paddingVertical: isMobile || isTab ? 40 : 80,
      minHeight: isTab ? '30vh' : !isMobile ? '80vh' : undefined,
    } as BoxProps,
    imageContainer: {
      // width: isMobile ? '50%' : '100%',
      width: '50%',
      minWidth: 300,
      // minWidth: '40%',
      minHeight: isMobile ? 300 : isTab ? 280 : 400,
      // maxHeight: 500,
      ph: isMobile ? 30 : 0,
      marginRight: isMobile ? -30 : isTab ? -36 : -30,
      justifyContent: isMobile ? 'center' : 'center',
      alignItems: isMobile ? 'center' : 'flex-end',
    } as BoxProps,
    leftBox: {
      display: 'flex',
      width: isMobile ? '100%' : '50%',
      justifyContent: 'center',
      alignItems: 'center',
    } as BoxProps,
    buttonContainer: {
      flexDirection: 'row',
      flexWrap: 'wrap',
      flex: 1,
      justifyContent: isMobile ? 'flex-start' : 'space-between',
      minHeight: 120,
    } as BoxProps,
    footerBackground: {
      paddingVertical: 40,
      borderTopLeftRadius: isMobile ? 20 : 120,
      bg: 'WHITE',
      borderTopRightRadius: isMobile ? 20 : 120,
      zIndex: 999,
      mt: -120,
    } as BoxProps,
    formBox: {
      display: 'flex',
      flexDirection: breakpoint < 600 ? 'column' : 'row',
      justifyContent: 'space-around',
      backgroundColor: '#24397A' as ColorOptions,
      paddingVertical: 250,
      marginBottom: -150,
      paddingTop: !isMobile ? 100 : 24,
      borderTopLeftRadius: !isMobile ? 120 : 24,
      borderTopRightRadius: !isMobile ? 120 : 24,
      paddingHorizontal: responsivePadding,
    } as BoxProps,
    borderBox: {
      borderRightWidth: 1,
      borderBottomWidth: 1,
      height: '98%',
      width: '100%',
      position: 'absolute',
      // zIndex: -1,
      top: 28,
      left: 12,
      borderRightColor: 'BLUE',
      borderBottomColor: 'BLUE',
      borderRadius: 24,
    } as BoxProps,
  }
}

export default SeamlessPay
